import "@/components/styles/fonts.css";
import "@/components/styles/global.css";
import "@/components/styles/loaders.css";
import "@/components/styles/scrollbar.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
